import Request from './request';

async function fetch(data) {
    return Request('get', "api/stock-ins/get-wait-shelve-on-list", data);
}

async function fetchOne(id) {
    return Request('get', "api/stock-ins/get-shelve-on-detail/" + id);
}

async function submit(data) {
    return Request('post', "api/stock-ins/shelve-on" , data);
}

export default {
    fetch,
    fetchOne,
    submit,
};